module.exports = __webpack_public_path__ + "static/media/whatsapp_logo.5dd642c8.svg";